__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/fc4c35c5ff83742dc53be4419f5621d983431e6c/_next/";